module.exports = __webpack_public_path__ + "img/brt_ch_fay_enchantress_0.92bd6e82.png";